export const AppMode = () => (
  <div id="jane-app-mode" data-appmode="bloom"></div>
);
